function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(a, b) {
  for (var c, d = 0; d < b.length; d++) {
    c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
}

function _createClass(a, b, c) {
  return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), b && _setPrototypeOf(a, b);
}

function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(a);
}

function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}

function isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function _construct() {
  return _construct = isNativeReflectConstruct() ? Reflect.construct : function (b, c, d) {
    var e = [null];
    e.push.apply(e, c);
    var a = Function.bind.apply(b, e),
        f = new a();
    return d && _setPrototypeOf(f, d.prototype), f;
  }, _construct.apply(null, arguments);
}

function _isNativeFunction(a) {
  return -1 !== Function.toString.call(a).indexOf("[native code]");
}

function _wrapNativeSuper(a) {
  var b = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(a) {
    function c() {
      return _construct(a, arguments, _getPrototypeOf(this).constructor);
    }

    if (null === a || !_isNativeFunction(a)) return a;
    if ("function" != typeof a) throw new TypeError("Super expression must either be null or a function");

    if ("undefined" != typeof b) {
      if (b.has(a)) return b.get(a);
      b.set(a, c);
    }

    return c.prototype = Object.create(a.prototype, {
      constructor: {
        value: c,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(c, a);
  }, _wrapNativeSuper(a);
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _possibleConstructorReturn(a, b) {
  return b && ("object" == _typeof(b) || "function" == typeof b) ? b : _assertThisInitialized(a);
}

var Time = function (a) {
  function b(a) {
    var c;
    return _classCallCheck(this, b), c = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this)), c.value = a || 0, c;
  }

  return _inherits(b, a), _createClass(b, [{
    key: "valueOf",
    value: function value() {
      return this.value;
    }
  }, {
    key: "milliseconds",
    value: function value(a) {
      return this.value += b.milliseconds(a), this;
    }
  }, {
    key: "seconds",
    value: function value(a) {
      return this.value += b.seconds(a), this;
    }
  }, {
    key: "minutes",
    value: function value(a) {
      return this.value += b.minutes(a), this;
    }
  }, {
    key: "hours",
    value: function value(a) {
      return this.value += b.hours(a), this;
    }
  }, {
    key: "days",
    value: function value(a) {
      return this.value += b.days(a), this;
    }
  }, {
    key: "weeks",
    value: function value(a) {
      return this.value += b.weeks(a), this;
    }
  }], [{
    key: "milliseconds",
    value: function value(a) {
      return new b(a);
    }
  }, {
    key: "seconds",
    value: function value(a) {
      return b.milliseconds(1e3 * a);
    }
  }, {
    key: "minutes",
    value: function value(a) {
      return b.seconds(60 * a);
    }
  }, {
    key: "hours",
    value: function value(a) {
      return b.minutes(60 * a);
    }
  }, {
    key: "days",
    value: function value(a) {
      return b.hours(24 * a);
    }
  }, {
    key: "weeks",
    value: function value(a) {
      return b.days(7 * a);
    }
  }]), b;
}(_wrapNativeSuper(Number));

export default Time;